import { ReactNode } from "react"
import { Icon, IconRef } from "./Icon"
import { cn, tv } from "@utils/tw"
import { ButtonGroup } from "./ButtonGroup"

type Props = {
  icon?: IconRef
  title?: ReactNode | string
  description?: ReactNode | string
  actions?: ReactNode
  className?: string
}

export function NonIdealState(props: Props) {
  const styles = createStyles({})
  return (
    <div className={cn(styles.base(), props.className)}>
      {props.icon && <Icon name={props.icon} className={styles.icon()} />}
      {props.title && <div className={styles.title()}>{props.title}</div>}
      {props.description && <div className={styles.description()}>{props.description}</div>}
      {props.actions && <ButtonGroup className={styles.actions()}>{props.actions}</ButtonGroup>}
    </div>
  )
}

const createStyles = tv({
  base: ["@container-normal py-8 px-8 flex flex-col items-center"],
  slots: {
    icon: ["size-9 my-2"],
    title: ["text-lg font-semibold text-gray-800 text-center mb-1"],
    description: ["text-base text-gray-500 text-center mb-3"],
    actions: ["flex gap-4 mt-3"],
  },
})
